import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { BRAND, IMAGES } from "@/lib/data";
import { getContent } from "@/lib/api";

export const DEFAULT_TEXT = {
  home: {
    heroKicker: `${BRAND.since} · ${BRAND.district}`,
    heroTitle1: "Herzlich",
    heroTitle2: "willkommen bei",
    heroAccent: "La Contadina",
    heroText:
      'Die Pizzeria & Trattoria „La Contadina" ist der Klassiker unter unseren Lokalen. Erleben Sie eine echte „Reise nach Italien" – direkt in Dresden, in rustikaler und familiärer Atmosphäre.',
    aboutTitle: "Eine Familie, eine Leidenschaft.",
    aboutP1:
      "Gegründet im Jahr 1998 von der Familie Gagliardi, ist unser Lokal im Laufe der Zeit gewachsen – ohne dabei seinen authentischen und herzlichen Geist zu verlieren.",
    aboutP2:
      "Noch heute arbeitet die Familie Seite an Seite mit derselben Begeisterung wie am ersten Tag und erzählt eine Geschichte voller Aromen, Düfte und Lächeln.",
    oliveTitle: "Natives Olivenöl aus Kampanien",
    oliveText:
      "Unser Olivenöl stammt aus Auletta südlich von Neapel und wird von mehreren Familienbetrieben nach alter, regionaler Tradition hergestellt. In unserem Lokal können Sie es probieren und kaufen.",
    olivePrice: "1-Liter-Flasche · 21,80 €",
    takeawayTitle: "Speisen zum Mitnehmen",
    takeawayText:
      "Bei Selbstabholung 10 % Rabatt auf alle Speisen – ab 70 € eine Flasche Wein gratis dazu.",
    ctaTitle: "Ein Tisch, ein Abend in Italien",
    ctaText:
      "Reservieren Sie Ihren Abend bei La Contadina und lassen Sie sich von den Aromen der Tradition verzaubern.",
  },
  about: {
    introTitle: "Willkommen bei La Contadina – im Herzen von Dresden",
    introP1:
      "Im ruhigen Stadtteil Löbtau heißt Sie das Ristorante La Contadina in einer rustikalen und familiären Atmosphäre willkommen, in der jedes Detail die Leidenschaft für gutes Essen und die Liebe zur italienischen Tradition widerspiegelt.",
    introP2:
      "Gegründet im Jahr 1998 von der Familie Gagliardi, ist unser Lokal im Laufe der Zeit gewachsen – ohne dabei seinen authentischen und herzlichen Geist zu verlieren. Noch heute arbeitet die Familie Seite an Seite mit derselben Begeisterung wie am ersten Tag.",
    teamTitle: "Kreativität trifft auf Tradition",
    teamText:
      "Unser freundliches, aufmerksames und hilfsbereites Team heißt besonders Familien und Kinder herzlich willkommen. Unsere Köche interpretieren klassische italienische Rezepte mit einer persönlichen Note neu. Unsere Pizzabäcker arbeiten mit Leidenschaft und Hingabe und wählen nur hochwertige Zutaten.",
    locationTitle: "Eine Auszeit am Mittelmeer – in Dresden",
    locationText:
      "La Contadina befindet sich in Dresden, einer Stadt der Kunst und Kultur im Herzen Sachsens. Das Viertel Löbtau bietet eine gemütliche und ruhige Atmosphäre, ideal, um ein entspanntes Essen zu genießen. Bei schönem Wetter genießen Sie unsere Terrasse mit 110 Außenplätzen.",
  },
  olive: {
    kicker: "Ernte 2025 ist da – natives Olivenöl aus Kampanien.",
    title: "Eine Erde voller alter Aromen",
    p1: 'Kennen Sie die Region, in der die Zitronen blühen und in der „O Sole Mio" geschrieben wurde? Das ist Kampanien – kobaltblaues Meer, einsame Natur, Thermen und dampfende Pizza gehören ebenso dazu.',
    p2: 'Unser Olivenöl kommt aus Auletta (Kreis Salerno) südlich von Neapel, bekannt durch „Die Grotte von Pertosa". Es wird von mehreren Familienbetrieben – zusammengeschlossen unter dem Titel „Una terra dai sapori antichi" – nach alter, regionaler Tradition hergestellt.',
    p3: 'Die Produktion beginnt jedes Jahr Ende November und endet im Januar. Die Früchte reifen in einem warmen und trockenen Sommer. Dokumentiert werden Prozesse und Berichte von der „Ölmühle der Familie Pucciarelli & Söhne" aus Auletta.',
    price: "21,80 €",
    quote: "„Idratato, soffice e riposato.",
    location: 'Auletta in provincia di Salerno, Campania · Contrada „Braide"',
  },
  contact: {
    title: "Reservieren & Besuchen",
    intro:
      "Wir freuen uns auf Ihren Besuch. Reservieren Sie online oder rufen Sie uns an.",
  },
  career: {
    heroTitle: "Arbeiten bei uns",
    heroText:
      "Werde Teil der Familie Gagliardi. Bei La Contadina verbinden wir italienische Gastfreundschaft mit einem herzlichen Miteinander – seit 1998.",
  },
  catering: {
    heroTitle: "Italien zu Ihrem Anlass",
    heroText:
      "Ob Hochzeit, Firmenfeier oder Familienfest – wir bringen authentische italienische Küche zu Ihnen. Wählen Sie ein Paket und fragen Sie unverbindlich an.",
  },
  gutschein: {
    heroTitle: "Geschenkgutscheine",
    heroText:
      "Eine Einladung zu einem Abend voller italienischer Aromen – das perfekte Geschenk für jeden Anlass. Erhältlich direkt bei uns im Lokal oder bequem online über unser Partner-Portal.",
  },
  legal: {
    impressum: `Angaben gemäß § 5 TMG

Pizzeria e Trattoria „La Contadina"
Familie Gagliardi
Reisewitzer Str. 49
01159 Dresden

Kontakt
Telefon: 0351 / 422 61 00
E-Mail: info@lacontadina-dresden.de

Umsatzsteuer-Identifikationsnummer (gemäß § 27a UStG):
[Bitte ergänzen]

Verantwortlich für den Inhalt (gemäß § 55 Abs. 2 RStV):
Familie Gagliardi, Anschrift wie oben

Streitschlichtung
Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`,
    datenschutz: `Datenschutzerklärung

1. Verantwortlicher
Pizzeria e Trattoria „La Contadina", Familie Gagliardi, Reisewitzer Str. 49, 01159 Dresden, Telefon 0351 / 422 61 00, E-Mail info@lacontadina-dresden.de.

2. Allgemeines
Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen (DSGVO, BDSG).

3. Reservierungen & Kontakt
Wenn Sie über unsere Website oder das eingebundene Reservierungssystem einen Tisch reservieren oder uns kontaktieren, verarbeiten wir die von Ihnen angegebenen Daten (z. B. Name, Telefon, E-Mail) zur Bearbeitung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.

4. Externe Dienste
Reservierung und Online-Bestellung werden über externe Anbieter abgewickelt; dabei gelten zusätzlich deren Datenschutzbestimmungen.

5. Ihre Rechte
Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Wenden Sie sich hierzu an die oben genannten Kontaktdaten.

Stand: [Bitte ergänzen / Datum].`,
  },
};

export const DEFAULT_SEO = {
  site: { titleSuffix: "La Contadina · Pizzeria & Trattoria Dresden" },
  home: {
    title: "La Contadina – Italienisches Restaurant in Dresden-Löbtau",
    description:
      "Authentische italienische Küche seit 1998 in Dresden-Löbtau. Pizza, Pasta & eigenes Olivenöl. Jetzt Tisch reservieren oder online bestellen.",
  },
  about: {
    title: "Über uns – La Contadina Dresden",
    description:
      "Familie Gagliardi führt La Contadina seit 1998. Rustikale Trattoria mit Terrasse im Herzen von Dresden-Löbtau.",
  },
  olive: {
    title: "Olivenöl aus Kampanien – La Contadina Dresden",
    description:
      "Natives Olivenöl aus eigener Produktion in Auletta, Kampanien. Bei uns probieren und kaufen – 1-Liter-Flasche.",
  },
  contact: {
    title: "Kontakt & Reservierung – La Contadina Dresden",
    description:
      "Reservieren Sie Ihren Tisch bei La Contadina in Dresden-Löbtau. Adresse, Öffnungszeiten und Anfahrt.",
  },
  career: {
    title: "Karriere – Arbeiten bei La Contadina Dresden",
    description:
      "Werde Teil des La-Contadina-Teams in Dresden-Löbtau. Offene Stellen in Service, Küche & mehr. Jetzt online bewerben.",
  },
  catering: {
    title: "Catering & Events – La Contadina Dresden",
    description:
      "Italienisches Catering für Hochzeit, Firmenfeier & mehr. Buffet, Pizza-Party & Business-Lunch. Jetzt unverbindlich anfragen mit Sofort-Preisschätzung.",
  },
  gutschein: {
    title: "Geschenkgutscheine – La Contadina Dresden",
    description:
      "Verschenken Sie italienischen Genuss: Geschenkgutscheine von La Contadina in Dresden-Löbtau. Erhältlich direkt im Lokal oder online über unser Partner-Portal.",
  },
};

const DEFAULTS = {
  brand: {
    phone: BRAND.phone,
    email: BRAND.email,
    address: BRAND.address,
    payment: BRAND.payment,
    hoursNote: BRAND.hoursNote,
    facebook: BRAND.facebook,
  },
  hours: BRAND.hours,
  banner: {
    enabled: true,
    title: "Betriebsferien",
    text: "Vom 7. Juli 2026 bis 22. Juli 2026 bleibt unser Lokal geschlossen. Ab dem 23. Juli sind wir wieder für Sie da!",
    startDate: "",
    endDate: "",
  },
  images: { ...IMAGES, heroVideo: "/hero.mp4", careerHero: "https://images.unsplash.com/photo-1745328196225-ed2cf3e51c19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", cateringHero: "https://images.unsplash.com/photo-1571162478581-ad3d0c1057ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", gutscheinHero: "https://images.unsplash.com/photo-1785724290111-f8b9901e7aee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", contactHero: "https://images.unsplash.com/photo-1579926545913-448d525562db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" },
  text: DEFAULT_TEXT,
  seo: DEFAULT_SEO,
  hoursSummer: BRAND.hours,
  season: "auto",
  seasonSummerStart: "2026-04-01",
  seasonWinterStart: "2026-11-01",
  gallery: [IMAGES.gallery1, IMAGES.gallery2, IMAGES.gallery3, IMAGES.gallery4],
  special: {
    enabled: false,
    kicker: "Saison-Spezial",
    title: "",
    text: "",
    ctaLabel: "",
    ctaUrl: "",
    startDate: "",
    endDate: "",
    image: "",
  },
  team: [],
  holidays: [],
  liveCam: {
    enabled: false,
    title: "Live aus unserer Küche",
    text: "Frisch aus dem Steinofen – sehen Sie live, was bei uns gerade gebacken wird.",
  },
  tageskarte: { enabled: true },
  streetView: "https://maps.google.com/maps?q=Reisewitzer%20Stra%C3%9Fe%2049%2C%2001159%20Dresden&layer=c&cbp=11,0,0,0,0&output=svembed",
};

function deepMerge(base, over) {
  if (Array.isArray(over)) return over;
  if (typeof over !== "object" || over === null) return over;
  const out = { ...base };
  for (const k of Object.keys(over)) {
    out[k] = k in base && typeof base[k] === "object" && !Array.isArray(base[k])
      ? deepMerge(base[k], over[k])
      : over[k];
  }
  return out;
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Schreibt gespeicherte absolute /api/files/-URLs (z. B. alte Preview-Domain) auf die
// aktuelle Backend-Domain um, damit Bilder/Videos auch nach dem Deploy laden.
function fixMediaUrls(value) {
  if (typeof value === "string") {
    const i = value.indexOf("/api/files/");
    if (i !== -1 && /^https?:\/\//.test(value)) return BACKEND_URL + value.slice(i);
    return value;
  }
  if (Array.isArray(value)) return value.map(fixMediaUrls);
  if (value && typeof value === "object") {
    const out = {};
    for (const k of Object.keys(value)) out[k] = fixMediaUrls(value[k]);
    return out;
  }
  return value;
}

export function buildContent(stored) {
  return fixMediaUrls({
    brand: { ...BRAND, ...DEFAULTS.brand, ...(stored.brand || {}) },
    images: { ...DEFAULTS.images, ...(stored.images || {}) },
    hours: stored.hours || DEFAULTS.hours,
    banner: { ...DEFAULTS.banner, ...(stored.banner || {}) },
    text: deepMerge(DEFAULT_TEXT, stored.text || {}),
    seo: deepMerge(DEFAULT_SEO, stored.seo || {}),
    hoursSummer: stored.hoursSummer || DEFAULTS.hoursSummer,
    season: stored.season || "auto",
    seasonSummerStart: stored.seasonSummerStart || DEFAULTS.seasonSummerStart,
    seasonWinterStart: stored.seasonWinterStart || DEFAULTS.seasonWinterStart,
    gallery: Array.isArray(stored.gallery) && stored.gallery.length ? stored.gallery : DEFAULTS.gallery,
    special: { ...DEFAULTS.special, ...(stored.special || {}) },
    team: Array.isArray(stored.team) ? stored.team : DEFAULTS.team,
    holidays: Array.isArray(stored.holidays) ? stored.holidays : DEFAULTS.holidays,
    liveCam: { ...DEFAULTS.liveCam, ...(stored.liveCam || {}) },
    tageskarte: { ...DEFAULTS.tageskarte, ...(stored.tageskarte || {}) },
    streetView: stored.streetView !== undefined ? stored.streetView : DEFAULTS.streetView,
  });
}

export function isSpecialActive(special) {
  if (!special || !special.enabled) return false;
  const today = new Date().toISOString().slice(0, 10);
  if (special.startDate && today < special.startDate) return false;
  if (special.endDate && today > special.endDate) return false;
  return true;
}

export const isBannerActive = isSpecialActive;

export const RAW_DEFAULTS = DEFAULTS;

const ContentContext = createContext(buildContent({}));

export function ContentProvider({ children }) {
  const [content, setContent] = useState(buildContent({}));

  const refresh = useCallback(async () => {
    try {
      const stored = await getContent();
      setContent(buildContent(stored || {}));
    } catch (e) {
      setContent(buildContent({}));
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
